/**
 * Single source for name, title, and copy used across the site and resume.
 */

export const NAME = 'Alexander Bell-Towne';

export const CONTACT_LINE = 'Seattle, WA • (509) 859-7437 • alexander@bell-towne.com • github.com/alexbbt';

export const TAGLINE = 'Senior Software Engineer and Technical Lead with 8+ years building large-scale commerce and payments platforms at Block, specializing in distributed systems and high-volume transaction infrastructure.';

export const META_DESCRIPTION = 'Senior Software Engineer and Technical Lead at Block (formerly Square). 8+ years building commerce and payments platforms.';

export const RESUME_WINDOW_TITLE = 'Alexander Bell-Towne Resume';

export const HOME_JOB_LINE = 'I work as a Senior Software Engineer and Technical Lead at Block, Inc. (formerly Square).';

export const HOME_DEGREE_LINE = 'I have a B.S. in Informatics from the University of Washington.';
